import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function VoiceSpeedSlider() {
  const { t } = useTranslation();
  const voiceSpeedRate = SettingsStore(state => state.voiceSpeedRate);
  const setVoiceSpeedRate = SettingsStore(state => state.setVoiceSpeedRate);
  const isLoading = SettingsStore(state => state.isLoading);

  // Handle slider value change (slider expects an array)
  const handleVoiceSpeedChange = (value: number[]) => {
    setVoiceSpeedRate(value[0]);
  };

  return (
    <ControlWrapper>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="voice-speed">{t("settings.voiceSpeedRate")}</Label>
          <span className="text-sm font-medium">{voiceSpeedRate}x</span>
        </div>
        <Slider
          id="voice-speed"
          min={0.5}
          max={1.5}
          step={0.1}
          value={[voiceSpeedRate]}
          onValueChange={handleVoiceSpeedChange}
          className="w-full"
          disabled={isLoading}
        />
        <div className="flex justify-between text-xs text-gray-500">
          <span>0.5x</span>
          <span>1.5x</span>
        </div>
      </div>
    </ControlWrapper>
  );
}